import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-descripction-requirement-list',
	templateUrl: './descripction-requirement-list.component.html',
	styleUrls: ['./descripction-requirement-list.component.css'],
})
export class DescripctionRequirementListComponent extends ListComponent {
	protected apiUrl = 'product/description_requirement';
	protected apiType = 'bag';
	module: any;
	productKinds: any;
	pageTitle: string;
	codebook;
	protected itemsBeforeDataLoad = 2;
	tableRows = [
		{ id: 'descriptionHeader', name: 'Nazwa' },
		{ id: 'isRequired', name: 'Wymagany do opublikowania oferty' },
	];
	filters = {
		limit: 9999,
		product_kind: null,
	};

	protected convertData(data: any) {
		return data.results.map((item) => {
			if (this.productKinds !== undefined) {
				const productKind = [this.productKinds.find((obj) => obj.id == item.productKind)];
				this.pageTitle = `Słowniki -> 
					${this.codebook.name} 
					->
					${productKind[0].name}`;
			}
			item.isRequired = item.isRequired ? 'tak' : 'nie';
			item.descriptionHeader = item.descriptionHeader?.name;
			return item;
		});
	}

	protected loadBefore() {
		const kind = this.route.snapshot.params['id'];
		this.bag.get('/product/kind/', (result, error) => {
			this.productKinds = result.results;
			this.loadData();
		});
		this.module = 'codebook/product_kind/description_requirement/' + kind;
		this.filters.product_kind = kind;
		this.bag.get('/codebook/1/', (result, error) => {
			this.codebook = result;

			this.loadData();
		});
	}
}
